// extracted by mini-css-extract-plugin
export default {"slideWrapper":"MainSlider_slideWrapper__ELFUL"};